var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-section",style:({
    flexDirection: _vm.getFlexDirection(_vm.secinfo.pos, _vm.secinfo.trains[0].ki)
  })},_vm._l((_vm.secinfo.trains),function(train){return _c('TrainBoxS',{key:train.tr,attrs:{"pos":_vm.secinfo.pos,"train":train,"unyo-list":_vm.unyoList}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }